// src/api/userAPI.js
import axiosInstance from '../utils/axios';

const siteAPI = {
    // CREATE
    createSite: (data) => axiosInstance.post('/sites/store', data),

    // READ
    getSites: (params) => axiosInstance.get('/sites', { params: params }),
    getActiveSites: (params) => axiosInstance.get('/sites', { params: params }),
    getSiteById: (id) => axiosInstance.get(`/sites/view/${id}`),
    getSiteDeposit: (params) => axiosInstance.get('/sites/total-deposit', { params: params }),

    // UPDATE
    updateSite: (id, data) => axiosInstance.put(`/sites/update/${id}`, data),

    // DELETE
    deleteSite: (id) => axiosInstance.delete(`/sites/delete/${id}`),
};

export default siteAPI;
